var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLogin)?[(!_vm.isRoute(_vm.routes.login))?_c('v-btn',{staticClass:"mx-2",attrs:{"to":_vm.route(_vm.routes.login),"text":"","tile":""}},[_vm._v("\n      "+_vm._s(_vm.$t('login'))+"\n    ")]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }